module.exports = __webpack_public_path__ + "img/chatwelcome.3c6b148f.png";